import {useEffect, useMemo} from 'react';
import type {ReactNode} from 'react';
import {useUrlParams} from 'utilities/use-url-params';
import {ShopLocalesAndMarketsContext} from 'utilities/use-shop-locales-and-markets';
import {useLoaderData} from 'react-router-dom';
import {LoaderType} from 'foundation/loader';

export function ShopLocalesAndMarkets({children}: {children: ReactNode}) {
  const {setUrlParams} = useUrlParams();

  const {
    shopLocalesAndMarkets: {
      locales,
      markets,
      currentLocale,
      primaryLocale,
      currentMarket,
    },
  } = useLoaderData<LoaderType>();

  // This handles the case where the user navigates to the app without
  // a locale in the URL. We want to set the locale to the current locale
  useEffect(() => {
    setUrlParams({
      shopLocale: currentLocale.locale,
      market: currentMarket?.handle,
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentLocale.locale, currentMarket?.handle]);

  const contextValues = useMemo(
    () => ({
      primaryLocale,
      currentLocale,
      locales,
      currentMarket,
      markets,
    }),
    [primaryLocale, currentLocale, locales, currentMarket, markets],
  );

  return (
    <ShopLocalesAndMarketsContext.Provider value={contextValues}>
      {children}
    </ShopLocalesAndMarketsContext.Provider>
  );
}
